<template>
    <b-container fluid>
        <b-row>
            <b-col class="font-weight-bold pt-0" cols="4">{{ $translate('comments') }}:</b-col>
            <b-col>{{ checkoff.comments || 'No Comments' }}</b-col>
        </b-row>
        <b-row>
            <b-col class="font-weight-bold pt-0" cols="4">{{ $translate('notes') }}:</b-col>
            <b-col>{{ checkoff.notes || 'No Comments' }}</b-col>
        </b-row>
        <b-row class="mt-4">
            <b-col class="font-weight-bold pt-0" cols="4">{{ $translate('signature_by') }}:</b-col>
            <b-col>{{ checkoff.user | filterName }}</b-col>
        </b-row>
        <b-row class="mt-4">
            <b-col class="font-weight-bold pt-0" cols="4">{{ $translate('email') }}:</b-col>
            <b-col>{{ checkoff.user.email }}</b-col>
        </b-row>
        <b-row class="mt-4" v-if="!!checkoff.signature_data">
            <b-col class="font-weight-bold pt-0" cols="4">{{ $translate('signature') }}:</b-col>
            <b-col><img :src="checkoff.signature_data" alt="signature" height="200px" width="800px"></b-col>
        </b-row>
    </b-container>
</template>


<script>
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'orders-ViewCheckoffSummary',
    mixins: [permissionsMixins],
    props: ['checkoff'],
    filters: {
        filterName(user) {
            return user.first_name + ' ' + user.last_name
        },
    },
}
</script>